import { EventsApiClient as EventsApiClientBase } from "./events.generated";
import { httpResult, parseDate, pipeRevivers } from "./utils";
// Extending the generated client allows us to do some configuration, including
// manipulation of returned data using a "reviver" function.
// https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator#add-a-custom-jsonparse-reviver-function
class EventsApiClient extends EventsApiClientBase {
    constructor(baseUrl = window.location.origin, http){
        super(baseUrl, http);
        this.jsonParseReviver = pipeRevivers([
            parseDate("Start"),
            parseDate("End"),
            parseDate("from"),
            parseDate("to")
        ]);
    }
}
const client = new EventsApiClient();
export const fetchEventDetails = (eventId)=>()=>httpResult(async ()=>{
            const result = await client.getDetails(eventId);
            return result.Result;
        });
export const fetchEvents = (params)=>()=>httpResult(async ()=>{
            const { page, pageSize, from, to, tags, regions, locations, query } = params;
            const result = await client.getOverview(page, pageSize, from, to, tags, regions, locations, query);
            return result;
        });
export const fetchFilterOptions = ()=>httpResult(async ()=>{
        const result = await client.getOverviewFilters();
        return result.Result;
    });
